import 'vuetify/styles'
// The MDI webfont is intentionally NOT loaded (~300KB saved): Font Awesome is
// the only icon set in use (see .claude/rules/styles.md). The mdi iconset
// registration below stays as an API fallback, but any mdi-* usage will render
// unstyled until the font import is restored.
import '@fortawesome/fontawesome-free/css/all.css'
import { createVuetify } from 'vuetify'
import { aliases, fa } from 'vuetify/iconsets/fa'
import { mdi } from 'vuetify/iconsets/mdi'

export const vuetify = createVuetify({
	icons: {
		defaultSet: 'fa',
		aliases,
		sets: { fa, mdi },
	},
	theme: {
		defaultTheme: 'tamiLight',
		themes: {
			tamiLight: {
				dark: false,
				colors: {
					primary: '#892a54',
					secondary: '#46c8de',
					// Dark indigo used for the "Export List" action (Vue 2 parity: that
					// button uses Vue 2's `secondary` = #333655, which V3 repurposed for cyan).
					'secondary-dark': '#333655',
					accent: '#00aec5',
					background: '#f5f5f7',
					surface: '#ffffff',
					'surface-variant': '#f0f0f5',
					// Vuetify's default light theme pairs a DARK surface-variant with a
					// near-white on-surface-variant; overriding only the background left
					// white-on-white text (e.g. invisible stepper step numbers).
					'on-surface-variant': '#111d2b',
					error: '#ff5252',
					warning: '#fb8c00',
					success: '#00d084',
					info: '#2196f3',
					'on-primary': '#ffffff',
					'on-background': '#1a2332',
					'on-surface': '#111d2b',
				},
			},
			tamiDark: {
				dark: true,
				colors: {
					primary: '#892a54',
					secondary: '#6eeaff',
					'secondary-dark': '#333655',
					accent: '#46c8de',
					background: '#0c1520',
					surface: '#111d2b',
					'surface-variant': '#182a3c',
					// Mirror of tamiLight: the dark default pairs on-surface-variant
					// black — unreadable on our dark surface-variant.
					'on-surface-variant': '#e7e7f1',
					error: '#ff5252',
					warning: '#fb8c00',
					success: '#00d084',
					info: '#2196f3',
					'on-primary': '#ffffff',
					'on-background': '#e7e7f1',
					'on-surface': '#e7e7f1',
				},
			},
		},
	},
	defaults: {
		VBtn: { variant: 'flat' },
		VCard: { rounded: 'lg' },
		VTextField: { variant: 'outlined', density: 'comfortable' },
		VSelect: { variant: 'outlined', density: 'comfortable' },
		VDialog: { transition: 'dialog-bottom-transition' },
		VTooltip: { transition: 'fade-transition' },
	},
})
